import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalVariant
} from '@patternfly/react-core';
import React from 'react';

export interface RemoveConfirmModal {
  /** is the confirmation modal visible */
  isOpen: boolean;
  /** Callback function to remove */
  onRemoveConfirm(event: KeyboardEvent | React.MouseEvent): void;
  /** Callback when the removal is dismissed */
  onRemoveCancel(event: KeyboardEvent | React.MouseEvent): void;
  /** confirmation message */
  confirmationMessage?: string;
  /** modal title */
  modalTitle?: string;
}

export const RemoveConfirmModal: React.FunctionComponent<RemoveConfirmModal> = ({
  isOpen,
  confirmationMessage = "Confirm removal?",
  modalTitle = "Confirm removal?",
  ...props
}) => (
  <Modal variant={ModalVariant.small} title={modalTitle} isOpen={isOpen} onClose={props.onRemoveCancel}>
    <ModalHeader title="Confirmation" titleIconVariant='warning' />
    <ModalBody>
      <p>{confirmationMessage}</p>
      <p>{"This action cannot be undone!"}</p>
    </ModalBody>
    <ModalFooter>
      <Button key="confirm" variant="danger" onClick={props.onRemoveConfirm}>Confirm</Button>
      <Button key="cancel" variant="link" onClick={props.onRemoveCancel}>Cancel</Button>
    </ModalFooter>
  </Modal>
);
